import API from './Api.js';
import Utils from "./utils.js";
import router from "./Router.js";
import {eventBus, EVENTS} from "./EventBus.js";

/* set / unset dei preferiti */

$(document).on(  {

    click: function() {

        var user_id;

        var id_elem = $(this).parents(".container_set_preferito").attr("data-id");
        var type = $(this).parents(".container_set_preferito").attr("data-type");
        var mastercontrol_id = "";
        if(type == "song"){

            mastercontrol_id = $(this).parents(".container_set_preferito").attr("data-masterid");

            if(!$(this).hasClass("liked")) {
                eventBus.emit(EVENTS.SONG_FAVORITE);
            }

        }

        var add_like = 0;

        if($(this).hasClass("liked")){
            add_like =  1;
        }

        // $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").toggleClass("liked");

        user.checkUser(function(_user){
            user_id = _user.userid;
        });
            if(user_id){
                API.post("community/set_like", {id_elem: id_elem, user_id: user_id, type: type, deleted : add_like, song_mdbid: mastercontrol_id }, function (resp) {
                    user.saveLocalUser(resp.user);
                    $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").toggleClass("liked");

                });
            } else {
                user.checkUser_preferiti(id_elem, type, add_like, mastercontrol_id);
            }


        // $(this).toggleClass("liked");
    }

}, ".set_preferiti");



/* cancellazione dei preferiti (podcast) */

$(document).on(  {

    click: function(){
        $(this).prev(".set_preferiti").trigger("click");
    }

}, ".set_preferiti_text");

$(document).on(  {

    click: function() {

        // if(confirm("Vuoi veramente rimuovere il podcast dai preferiti?")) {

            var user_id;

            var id_elem = $(this).parents(".episodio-preferito-block-container").attr("data-id");
            var type = $(this).parents(".episodio-preferito-block-container").attr("data-type");

            user.checkUser(function (user) {
                user_id = user.userid;
            });

            Utils.showWaitingLoader();

            API.post("community/set_like", {
                id_elem: id_elem,
                user_id: user_id,
                type: type,
                deleted: 0
            }, function (resp) {

                Utils.hideWaitingLoader();
                user.saveLocalUser(resp.user);
                $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").removeClass("liked");

                // reimposto il paginatore
                if(user.paginatore_podcast_preferiti) {
                    user.paginatore_podcast_preferiti.init(null, {total: user.paginatore_podcast_preferiti.total - 1});
                    user.paginatore_podcast_preferiti.reset();
                }

                // rimuovo l'elemento
                $("#episodio-preferito-block-container-child-"+id_elem).fadeOut(500);
                $("#episodio-preferito-block-container-child-"+id_elem).remove();

            });

        // }

    }

}, ".delete-podcast");


$(document).on(  {

    click: function() {

        // if(confirm("Vuoi veramente rimuovere il podcast dai preferiti?")) {

            var user_id;

            var id_elem = $(this).parents(".container_action_single_pod").attr("data-id");
            var type = $(this).parents(".container_action_single_pod").attr("data-type");

            user.checkUser(function (user) {
                user_id = user.userid;
            });

            Utils.showWaitingLoader();
            window.setMyFavorite();

            API.post("community/set_like", {
                id_elem: id_elem,
                user_id: user_id,
                type: type,
                deleted: 0
            }, function (resp) {

                Utils.hideWaitingLoader();

                user.saveLocalUser(resp.user);

                // reimposto il paginatore
                if(user.paginatore_podcast_video_preferiti) {
                    user.paginatore_podcast_video_preferiti.init(null, {total: user.paginatore_podcast_video_preferiti.total - 1});
                    user.paginatore_podcast_video_preferiti.reset();
                }

                // rimuovo l'elemento
                $("#single_podcast_video_preferiti-"+id_elem).fadeOut(500);
                $("#single_podcast_video_preferiti-"+id_elem).remove();

            });

        // }

    }

}, ".delete-podcast-video");

/* download dei podcast */

$(document).on(  {

    click: function() {

        let url = $(this).parents(".episodio-preferito-block-container").find(".player").attr("data-audio");
        let nome = $(this).parents(".episodio-preferito-block-container").find(".title").html();
        Utils.downloadURI(url, nome);

    }

}, ".download_podcast_preferito");

/* cancellazione dei preferiti (canzoni) */

$(document).on(  {

    click: function() {

        // if(confirm("Vuoi veramente rimuovere la canzone dai preferiti?")) {

            var user_id;

            var id_elem = $(this).parents(".scopri-anche-block").attr("data-id");
            var song_mdbid = $(this).parents(".scopri-anche-block").attr("data-song_mdbid");
            var type = $(this).parents(".scopri-anche-block").attr("data-type");

            user.checkUser(function (user) {
                user_id = user.userid;
            });

            Utils.showWaitingLoader();

            API.post("community/set_like", {
                id_elem: id_elem,
                song_mdbid: song_mdbid,
                user_id: user_id,
                type: type,
                deleted: 0
            }, function (resp) {

                Utils.hideWaitingLoader();

                user.saveLocalUser(resp.user);
                $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").removeClass("liked");

                // reimposto il paginatore
                if(user.paginatore_canzoni_preferite) {
                    user.paginatore_canzoni_preferite.init(null, {total: user.paginatore_canzoni_preferite.total - 1});
                    user.paginatore_canzoni_preferite.reset();
                }

                // rimuovo l'elemento
                $("#scopri-anche-block-"+id_elem).fadeOut(500);
                $("#scopri-anche-block-"+id_elem).remove();

            });

        // }

    }

}, ".delete-song");


$(document).on(  {

    click: function() {

        // if(confirm("Vuoi veramente rimuovere la categoria dai preferiti?")) {

            var user_id;

            var id_elem = $(this).parents(".scopri-anche-block").attr("data-id");

            var type = $(this).parents(".scopri-anche-block").attr("data-type");

            user.checkUser(function (user) {
                user_id = user.userid;
            });

            Utils.showWaitingLoader();

            API.post("community/set_like", {
                id_elem: id_elem,
                user_id: user_id,
                type: type,
                deleted: 0
            }, function (resp) {

                Utils.hideWaitingLoader();

                user.saveLocalUser(resp.user);

                // reimposto il paginatore
                if(user.paginatore_categorie_preferiti) {
                    user.paginatore_categorie_preferiti.init(null, {total: user.paginatore_categorie_preferiti.total - 1});
                    user.paginatore_categorie_preferiti.reset();
                }

                // rimuovo l'elemento
                $("#scopri-anche-block-categoria-"+id_elem).fadeOut(500);
                $("#scopri-anche-block-categoria-"+id_elem).remove();

            });

        // }

    }

}, ".delete-categoria");

$(document).on(  {

    click: function() {
        $(".container_blue_action_all").not( $(this).siblings(".container_blue_action_all")).hide();

       $(this).siblings(".container_blue_action_all").toggle();

    }

}, ".click_to_open_menu");

$(document).on(  {

    click: function() {
       $(".container_blue_action_all").hide();
    }

}, ".blue_in_mobile");

///// PARTE PER GESTIRE MENU CON TRE PUNTINI MOBILE RELATIVO AI PODCAST IN MOBILE MA DEVE ESSERE ATTIVO IN TUTTE LE PAGINE



